import { OrderedColumnsT } from 'business/definitions';
import { getBestSuitableRemainingColumn } from './helpers';

const AGENT_AGE_COLUMN_KEY = 'agent.age';
const NB_AGENTS_COLUMN_KEY = 'agent';

/**
 * Finds the ordered columns of a pyramid visualization.
 * Since choosing this visualization from the interface is not possible as a user, we know for sure how to display it
 * That's why we put the number of agents as y, their age as x and any remaining column (usually the agent sex) as z.
 */
export const getPyramidOrderedColumns = (
    chartColumns: ResponseColumnT[],
): OrderedColumnsT => {
    const ageColumn = chartColumns.find(
        (col) => col.key === AGENT_AGE_COLUMN_KEY,
    );
    const nbAgentsColumn = chartColumns.find(
        (col) => col.key === NB_AGENTS_COLUMN_KEY,
    );
    if (!nbAgentsColumn) return { y: chartColumns[0] };
    return {
        x: ageColumn,
        y: nbAgentsColumn,
        z: getBestSuitableRemainingColumn(chartColumns, [
            AGENT_AGE_COLUMN_KEY,
            NB_AGENTS_COLUMN_KEY,
        ]),
    };
};
